/**
 * Timer utility for countdown functionality
 * Handles countdown timer creation and cleanup
 */

/**
 * Creates a countdown timer with automatic cleanup
 * @param {string} targetDate - Target date string
 * @param {string} elementId - DOM element ID to update
 * @param {Function} onTick - Callback function for each tick
 * @param {Function} onComplete - Callback function when timer completes
 * @returns {number} - Interval ID for cleanup
 */
export function createCountdownTimer(targetDate, elementId, onTick, onComplete) {
  const countDownDate = new Date(targetDate).getTime();
  let intervalId = null;

  const tick = () => {
    const distance = countDownDate - new Date().getTime();

    if (distance <= 0) {
      clearInterval(intervalId);
      onComplete && onComplete();
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    onTick && onTick({ days, hours, minutes, seconds, distance }, elementId);
  };

  tick();
  intervalId = setInterval(tick, 1000);

  return intervalId;
}

/**
 * Formats timer HTML for display
 * @param {Object} timerData - Timer data object
 * @param {Object} translations - Translation object with the required keys
 * @returns {string} - Formatted HTML string
 */
export function formatTimerHTML(timerData, translations) {
  const { days, hours, minutes, seconds } = timerData;

  return `
    <div>${days}<span>${translations.days}</span></div>
    <div>${hours}<span>${translations.hours}</span></div>
    <div>${minutes}<span>${translations.mins}</span></div>
    <div>${seconds}<span>${translations.secs}</span></div>
  `;
}
